// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBBksgpWbkVjwnwuWsLtjWCZOgA1yD3h_g',
    authDomain: 'ausmit-33c1c.firebaseapp.com',
    projectId: 'ausmit-33c1c',
    storageBucket: 'ausmit-33c1c.appspot.com',
    messagingSenderId: '493198370706',
    appId: '1:493198370706:web:0bc81dcfef17b81c57034b',
    measurementId: 'G-ZRL175HM48',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
